import React, { memo } from "react";
import {
  CARD_INNER_STYLE,
  CARD_FACE_STYLE,
  CARD_BACK_STYLE,
  CARD_IMAGE_STYLE,
} from "./carouselShared";

interface CarouselCardProps {
  card: {
    id: number;
    front: string;
    back: string;
    alt: string;
  };
  index: number;
  opacity: number;
  onClick: (index: number) => void;
  onRef?: (el: HTMLDivElement | null) => void;
  style?: React.CSSProperties;
  thumbnailStyle?: React.CSSProperties;
  ThumbnailComponent: React.ComponentType<any>;
}

const CarouselCard = memo<CarouselCardProps>(
  ({
    card,
    index,
    opacity,
    onClick,
    onRef,
    style,
    thumbnailStyle,
    ThumbnailComponent,
  }) => {
    const handleClick = React.useCallback(() => {
      onClick(index);
    }, [onClick, index]);

    return (
      <ThumbnailComponent
        ref={onRef}
        style={{
          opacity,
          pointerEvents: "auto",
          ...thumbnailStyle,
        }}
        onClick={handleClick}
      >
        <div className="card-inner" style={CARD_INNER_STYLE}>
          <div className="card-face card-front" style={CARD_FACE_STYLE}>
            <img
              src={card.front}
              alt={card.alt}
              draggable={false}
              style={CARD_IMAGE_STYLE}
            />
          </div>
          <div className="card-face card-back" style={CARD_BACK_STYLE}>
            <img
              src={card.back}
              alt={`${card.alt} hover`}
              draggable={false}
              style={CARD_IMAGE_STYLE}
            />
          </div>
        </div>
      </ThumbnailComponent>
    );
  },
);

CarouselCard.displayName = "CarouselCard";

export default CarouselCard;
